import { isDateValid, cpf, fullName } from '@convenia/helpers'
import { pis, minLength, maxLength } from '../rules'
import { extend } from '../helpers'

extend('date', {
  validate: isDateValid,
  message: 'Data inválida'
})

extend('cpf', cpf)
extend('pis', pis)
extend('fullName', fullName)
extend('minLength', minLength)
extend('maxLength', maxLength)
